var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimerRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0147 2.84304L14.7354 6.34184C14.9189 7.25258 14.3358 8.14366 13.425 8.32712C12.5143 8.51057 11.6232 7.92744 11.4398 7.0167L10.719 3.5179C10.5356 2.60716 11.1187 1.71608 12.0294 1.53262C12.9402 1.34917 13.8313 1.9323 14.0147 2.84304Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1786 2.59411L10.4767 3.35415C9.79524 3.49174 9.12693 3.05275 8.98934 2.37134C8.85174 1.68992 9.29073 1.02161 9.97215 0.88402L13.6806 0.12398C14.362 -0.0136131 15.0303 0.425375 15.1679 1.10679C15.3055 1.78821 14.8665 2.45652 14.1786 2.59411Z",
    fill: "#C63838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9525 18.4567C25.9525 23.9473 21.484 28.4092 16 28.4092C10.5159 28.4092 6.04736 23.9407 6.04736 18.4567C6.04736 12.9791 10.5159 8.51062 16 8.51062C21.484 8.51062 25.9525 12.9791 25.9525 18.4567Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 5.00525C8.57644 5.00525 2.54199 11.0463 2.54199 18.4566C2.54199 25.8801 8.583 31.9146 15.9999 31.9146C23.4169 31.9146 29.4579 25.8736 29.4579 18.4566C29.4579 11.0463 23.4234 5.00525 15.9999 5.00525ZM15.9999 28.4092C10.5093 28.4092 6.04735 23.9407 6.04735 18.4566C6.04735 12.9791 10.5159 8.5106 15.9999 8.5106C21.484 8.5106 25.9525 12.9791 25.9525 18.4566C25.9525 23.9473 21.4906 28.4092 15.9999 28.4092Z",
    fill: "#C63838"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4499 17.1438H21.8874C22.5562 17.1438 23.0937 17.6875 23.0937 18.35C23.0937 19.0188 22.5499 19.5563 21.8874 19.5563H16.4499C15.7812 19.5563 15.2437 19.0125 15.2437 18.35C15.2437 17.6875 15.7874 17.1438 16.4499 17.1438Z",
    fill: "#313131"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0562 20.775C17.3057 20.775 18.3187 19.6921 18.3187 18.3563C18.3187 17.0204 17.3057 15.9375 16.0562 15.9375C14.8067 15.9375 13.7937 17.0204 13.7937 18.3563C13.7937 19.6921 14.8067 20.775 16.0562 20.775Z",
    fill: "#ED8103"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerRed);
export default __webpack_public_path__ + "static/media/timer-red.cc150c12a91f27826cf455ea47797be5.svg";
export { ForwardRef as ReactComponent };